import {forwardRef, HTMLProps, ReactNode} from "react";

interface IProps {
  children?: ReactNode;
}

export const TwTable = forwardRef<HTMLTableSectionElement, IProps & HTMLProps<HTMLTableSectionElement>>(
  function TwTableInner({children, className, ...rest}, ref) {
    return (
      <div {...rest} className={`relative overflow-x-auto shadow-md sm:rounded-lg ${className}`} ref={ref}>
        <table className="table-auto w-full text-sm text-left rtl:text-right text-gray-500">{children}</table>
      </div>
    );
  }
);

export const TwTableHead = forwardRef<HTMLTableSectionElement, IProps & HTMLProps<HTMLTableSectionElement>>(
  function TwTableHeadInner({children, className, ...rest}, ref) {
    return (
      <thead {...rest} className={`text-xs text-gray-700 bg-gray-100 ${className}`} ref={ref}>
        <tr>{children}</tr>
      </thead>
    );
  }
);

export const TwTableFoot = forwardRef<HTMLTableSectionElement, IProps & HTMLProps<HTMLTableSectionElement>>(
  function TwTableFootInner({children, className, ...rest}, ref) {
    return (
      <tfoot {...rest} className={`text-xs text-gray-700 bg-gray-50 ${className}`} ref={ref}>
        {children}
      </tfoot>
    );
  }
);

export const TwTableFootRow = forwardRef<HTMLTableRowElement, IProps & HTMLProps<HTMLTableRowElement>>(
  function TwTableFootRowInner({children, className, ...rest}, ref) {
    return (
      <tr {...rest} className={className} ref={ref}>
        {children}
      </tr>
    );
  }
);

export const TwTableHeader = forwardRef<HTMLTableCellElement, IProps & HTMLProps<HTMLTableCellElement>>(
  function TwTableHeaderInner({children, className, ...rest}, ref) {
    return (
      <th {...rest} className={`uppercase px-4 py-2 ${className}`} ref={ref}>
        {children}
      </th>
    );
  }
);

export const TwTableBody = forwardRef<HTMLTableSectionElement, IProps & HTMLProps<HTMLTableSectionElement>>(
  function TwTableBodyInner({children, className, ...rest}, ref) {
    return (
      <tbody {...rest} className={className} ref={ref}>
        {children}
      </tbody>
    );
  }
);

export const TwTableRow = forwardRef<HTMLTableRowElement, IProps & HTMLProps<HTMLTableRowElement>>(
  function TwTableRowInner({children, className, ...rest}, ref) {
    return (
      <tr {...rest} className={`bg-white border-b border-gray-200 hover:bg-gray-50  ${className}`} ref={ref}>
        {children}
      </tr>
    );
  }
);

export const TwTableCell = forwardRef<HTMLTableCellElement, IProps & HTMLProps<HTMLTableCellElement>>(
  function TwTableCellInner({children, className, ...rest}, ref) {
    return (
      <td {...rest} className={`px-4 py-2 ${className}`} ref={ref}>
        {children}
      </td>
    );
  }
);
